export default class TrackingService {

    constructor() {
        //fix npe if o tracking is not available
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            this.global.eventQBus = {
                emit: () => {
                }
            }
        }
    }

    sendLargeShoppromoInitialViewTrackingEvent(featureOrder, featureIndex, filledSlots, slides) {
        if (slides.length === 0) {
            return
        }

        let trackingData = [this._createLargeShoppromoLabel(featureOrder, featureIndex, filledSlots, "loaded")];

        [].forEach.call(slides, (slide, i) => {
            slide.setIsTracked();
            trackingData.push(this._createLargeShoppromoTileLabel(i + 1, featureIndex, slide.getDreson(), slide.getUrlPath(), "loaded"));
        });

        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingData);
    }

    sendSlideTrackingEvent(legacyTrackingData, movementType, featureOrder, featureIndex, slide, positionInSlider, filledSlots) {
        let name = "automatic";
        if (movementType === "right") {
            name = "next";
        } else if (movementType === "left") {
            name = "previous";
        }
        this._sendTrackingEvent(name, featureOrder, featureIndex, filledSlots, positionInSlider, slide, legacyTrackingData, "loaded", "tracking.bct.submitAction");
    }

    sendClickTrackingEvent(legacyTrackingData, featureOrder, featureIndex, slide, positionInSlider, filledSlots) {
        this._sendTrackingEvent("click", featureOrder, featureIndex, filledSlots, positionInSlider, slide, legacyTrackingData, "clicked", "tracking.bct.submitMoveAction")
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": "ShopPromotionLarge"});
    }

    _sendTrackingEvent(name, featureOrder, featureIndex, filledSlots, positionInSlider, slide, legacyTrackingData, status, submitAction ) {
        let trackingData = {
            name: name,
            features: [this._createLargeShoppromoLabel(featureOrder, featureIndex, filledSlots, status),
                this._createLargeShoppromoTileLabel(positionInSlider, featureIndex, slide.getDreson(), slide.getUrlPath(), status)]
        }
        let pageCluster = window.o_util.misc.getPagecluster();
        // Replace legacy tracking data with own object when old tracking is obsolete
        legacyTrackingData["wk.promo_AttributionFeature"] = `ShopPromotionLarge_${pageCluster}`;
        legacyTrackingData["wk.promo_AttributionSource"] = "manual";

        this.global.eventQBus.emit(submitAction, legacyTrackingData, trackingData);
    }

    _createLargeShoppromoLabel(featureOrder, featureIndex, filledSlots, status) {
        let labels = {};
        labels.promo_Feature = [true];
        labels.promo_FilledSlots = [filledSlots];
        labels.promo_FeatureNumber = [featureIndex + 1];

        return {
            id: 'ft3_soprla' + featureIndex,
            name: "ShopPromotionLarge",
            position: featureOrder,
            status: status,
            labels: labels
        }
    }

    _createLargeShoppromoTileLabel(positionInSlider, featureIndex, dreson, urlPath, status) {
        let trackingPayload = {
            id: "ft3_soprla" + featureIndex + "_tile" + positionInSlider,
            parentId: "ft3_soprla" + featureIndex,
            name: "ShopPromotionLarge-Tile",
            position: positionInSlider,
            status: status,
            labels: {
                promo_Content: [urlPath],
                promo_TargetPsr: [dreson],
                promo_Source: ["manual"],
            }
        };
        return trackingPayload
    }

}
